function build_table_header(raw_header){
    let header = [];
    raw_header.forEach((item) => {
        header.push({"text": item['text'],
        "options":{
            fontFace: 'Century Gothic',
            fontSize: 9,
            bold: true,
            color: '#ffffff',
            fill: '#020446',
            align: 'left',
        }
        })
    })
    console.log(header)
    return header
}
function build_table_values(raw_header){
    let header = [];
    raw_header.forEach((item) => {
        console.log(item)
        header.push(item['value'])
    })
    console.log(header)
    return header
}

function build_table_body(raw_body, header){
    let statistics_data = [];
    raw_body.forEach((raw_row) => {
        let row = [];
        header.forEach((column) => {
            let cellValue = raw_row[column];
            if (cellValue === null || cellValue === undefined) {
                row.push('');
            } else {
                row.push(String(cellValue));
            }
        })
        statistics_data.push(row);
    })
    return statistics_data
}

function format_number(number){
    return number.toLocaleString();
}

export {build_table_header, build_table_body, format_number, build_table_values}
